<template>
  <v-layout column ma-0 pa-0 style="margin:0;padding:0;" align-center>
    <v-layout row align-start>
      <v-btn color="success" @click="pre" v-show="currentPage>1">上一页</v-btn>
      <v-btn color="success" @click="next" v-show="currentPage<pageCount">下一页</v-btn>
    </v-layout>
    <pdf style="border: 1px solid red; width: 80%;" :src="src" :page="currentPage" @num-pages="pageCount = $event"
      @page-loaded="currentPage = $event"></pdf>
    <v-layout row align-end>
      <v-btn color="success" @click="pre" v-show="currentPage>1">上一页</v-btn>
      <v-btn color="success" @click="next" v-show="currentPage<pageCount">下一页</v-btn>
    </v-layout>
  </v-layout>
</template>

<style scoped>

</style>

<script>
  import GhPdf from "./ghPdf.ts";
  export default GhPdf;
</script>